<template>
    <div class="app-empty flex flex-col items-center justify-center">
        <div class="w-48px">
            <img :src="imgSrc" alt="empty" class="w-full h-full"></img>
        </div>
        <div class="no-data">
            {{ title }}
        </div>
        <div class="empty-btn mt-15px" v-if="showBtn" @click="handleBtnClick">
            {{ btnText }}
        </div>
    </div>
</template>

<script setup lang="ts">
import theme from '@/styles/theme';
import likeEmpty from '@/assets/images/mine/like.webp';
import { useRouter } from 'vue-router';
const router = useRouter();
defineProps({
    showBtn: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: 'No Data',
    },
    btnText: {
        type: String,
        default: 'Chat Now',
    },
    imgSrc: {
        type: String,
        default: likeEmpty,
    },
});

const handleBtnClick = () => {
    router.push('/');
}
</script>

<style scoped lang="scss">
.app-empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
}

.no-data {
    font-weight: 900;
    font-size: 12px;
    color: v-bind('theme.colors.textPrimary');
    text-align: center;
    font-weight: 500;
}

.empty-btn {
    width: 210px;
    height: 36px;
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    border-radius: 20px;
    font-weight: 900;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    line-height: 36px;
}
</style>